import { render } from "./pajamasConfig.vue?vue&type=template&id=7431aa7f&ts=true"
import script from "./pajamasConfig.vue?vue&type=script&lang=ts"
export * from "./pajamasConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__